import React from 'react';
import QuemSomos from '../components/QuemSomos';
import WhatsappFloat from '../components/WhatsappFloat';
import { Helmet } from 'react-helmet-async';

const QuemSomosPage = () => {
  return (
    <div className="quem-somos-page">
      <Helmet>
        <title>Quem Somos | MicroCodie</title>
        <meta name="description" content="Conheça a trajetória, cultura, equipe e valores da MicroCodie. Transformando ideias em soluções digitais." />
        <meta property="og:title" content="Quem Somos | MicroCodie" />
        <meta property="og:description" content="Conheça a trajetória, cultura, equipe e valores da MicroCodie. Transformando ideias em soluções digitais." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.microcodie.com.br/quem-somos" />
        <meta property="og:image" content="/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Quem Somos | MicroCodie" />
        <meta name="twitter:description" content="Conheça a trajetória, cultura, equipe e valores da MicroCodie. Transformando ideias em soluções digitais." />
        <meta name="twitter:image" content="/logo192.png" />
        <link rel="canonical" href="https://www.microcodie.com.br/quem-somos" />
      </Helmet>
      <QuemSomos />
      <WhatsappFloat />
    </div>
  );
};

export default QuemSomosPage; 